<template>
    <div class="materialScience">
        <div class="top">
            <img class="materialScience-img" src="../../../assets/images/degreeApplication/materialScience.png" alt="">
        </div>
        <div class="cont">
            <h1 class="cont-title">申报材料</h1>
            <!-- <div class="tips">注意：一共7项材料，按如下顺序准备好纸质材料。</div> -->
            <div class="cont-item">
                <div class="item-title">（一）学士学位备案表一份。</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/application.png')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/application.png')]">
                    </el-image>
                </div>
            </div>
            <div class="cont-item">
                <div class="item-title">（二）毕业证扫描件一份。</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/diploma.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/diploma.jpg')]">
                    </el-image>
                </div>
            </div>
            <div class="cont-item">
                <div class="item-title">（三）英语考试如下材料之一：</div>
                <div class="item-text">1、全国大学英语四级及以上考试，成绩>350分；</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/englishExam1.png')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/englishExam1.png')]">
                    </el-image>
                </div>
                <div class="item-text">2、全国英语等级考试（PETS）三级及以上，笔试成绩合格；</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/englishExam2.png')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/englishExam2.png')]">
                    </el-image>
                </div>
                <div class="item-text">3、医学英语水平考试（METS）三级及以上，成绩合格；</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/englishExam3.png')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/englishExam3.png')]">
                    </el-image>
                </div>
            </div>
            <div class="cont-item">
                <div class="item-title">（四）全国计算机等级考试（NCRE）合格证扫描件一份。（附考试时间、考试科目备查）</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/certificateConformity.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/certificateConformity.jpg')]">
                    </el-image>
                </div>
            </div>
            <div class="cont-item">
                <div class="item-title">（五）毕业生总成绩单如下之一：</div>
                <div class="item-text">
                    1、成教毕业生成绩总表一份；
                    <!-- <a href="http://jxjycjcx.cqjtu.edu.cn/Account/Login?ReturnUrl=%2f" target="_blank">
                        <span class="color-blue">（成绩查询）</span>
                    </a> -->
                    </div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/cjchengji.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/cjchengji.jpg')]">
                    </el-image>
                </div>
                <!-- <div class="item-text">2、自考毕业生成绩总表一份，成绩单扫描件需加盖鲜章(成绩单原件在档案袋里，由档案保存单位盖鲜章，例如档案在人才交流市场由该单位盖鲜章)。</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/schoolReport.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/schoolReport.jpg')]">
                    </el-image>
                </div> -->
            </div>
            <div class="cont-item">
                <div class="item-title">（六）身份证复印件一份。</div>
            </div>
            <div class="cont-item">
                <div class="item-title">（七）纸质小二寸照片2张（姓名及身份证号写背面），</div>
                <div class="item-tips">
                    <p>注意：</p>
                    <p>
                        1、纸质小2寸照片，必须与本科毕业证照片一致。（
                        <span class="color-red">毕业证照片可在</span>
                        <a href="https://www.chsi.com.cn/" target="_blank">
                            <span class="color-blue">学信网</span>
                        </a>
                        <span class="color-red">上截取</span>
                        ）
                    </p>
                    <p>2、电子照片（必须命名为  张 三 513132199210121028.jpg），
                        <span class="color-red">电子照片大小为10一40KB且像素尺寸为（宽）480*（高）640，图片必须用jpg格式</span>。电子照片在网上申报时提交。</p>
                    <p>3、申请学位所需电子照片格式不符合要求者，将无法完成学位信息网上报送工作！</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'materialScience',
}
</script>

<style lang="scss" coped>
.materialScience{
    padding: 20px;
    .top{
        .materialScience-img{
            width: 150px;
            height: 100px;
            object-fit: contain;
        }
    }
    .cont{
        margin-top: 20px;
        .tips{
            font-size: 18px;
            color: red;
            font-weight: 700;
        }
        .cont-item{
            margin-top: 10px;
            font-size: 16px;
            .item-tips{
                padding-left: 40px;
            }
            .imgs{
                margin-top: 10px;
                // display: flex;
                // flex-direction: column;
                .img{
                    width: 300px;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
            .color-red{
                color: rgb(255, 0, 0);
            }
            .color-blue{
                color: #006dcc;
            }
            a:visited {
                color: #006dcc;
            }
            a:active, a:hover {
                color: #33a0ff;
            }
        }
    }
}
</style>
